import React from "react";
import { RoadmapBadge } from "../components/roadmap";

type Step = {
  title: string;
  subtitle: string;
  status: "available" | "progress" | "upcoming";
  items: string[];
};

const STEPS: Step[] = [
  {
    title: "Étape 1",
    subtitle: "Fondation & vitrine",
    status: "available",
    items: [
      "Pages principales : Accueil, Academy, Play, Assist",
      "Comptes de démonstration (visiteur)",
      "Interface clair / sombre",
      "Première cohérence narrative et pédagogique",
      "Outils de base Assist",
    ],
  },
  {
    title: "Étape 2",
    subtitle: "Academy : modules interactifs",
    status: "progress",
    items: [
      "Micro-cours pédagogiques (enfants / ados / adultes)",
      "Quiz interactifs",
      "Premiers parcours thématiques",
      "Suivi de progression simple",
      "Narration cognitive",
    ],
  },
  {
    title: "Étape 3",
    subtitle: "Play : mini-jeux cognitifs",
    status: "upcoming",
    items: [
      "Mini-jeux : Cherche & Vérifie, Vrai / Faux intelligent, jeux d’attention",
      "Défis du jour",
      "Classements et badges ludiques",
    ],
  },
  {
    title: "Étape 4",
    subtitle: "Assist avancé",
    status: "upcoming",
    items: [
      "Outils d’introspection",
      "Analyse cognitive d’une information",
      "Aide à la prise de décision",
      "Outil d’exposé assisté (plan → brouillon → version finale)",
      "Journaling mental",
      "Mode enseignants (correction assistée)",
    ],
  },
  {
    title: "Étape 5",
    subtitle: "Espace enseignants & écoles",
    status: "upcoming",
    items: [
      "Tableau de bord prof",
      "Suivi classe (progressions, quiz, jeux)",
      "Fiches pédagogiques prêtes à imprimer",
      "Scénarios pédagogiques clé en main",
      "Sessions de jeu synchronisées en classe",
      "Mode supervision et protection",
    ],
  },
  {
    title: "Étape 6",
    subtitle: "Espace famille avancé",
    status: "upcoming",
    items: [
      "Profils enfants personnalisables",
      "Rapports simplifiés pour les parents",
      "Filtres éducatifs basés sur la curiosité",
      "Indicateurs cognitifs simples",
    ],
  },
  {
    title: "Étape 7",
    subtitle: "MixMind Mobile",
    status: "upcoming",
    items: [
      "Application iOS / Android",
      "Mode “exercices 5 minutes par jour”",
      "Synchronisation avec comptes école et famille",
      "Mode hors-ligne (exposés, mini-jeux, journaling)",
    ],
  },
];

export default function Roadmap() {
  return (
    <div className="max-w-5xl mx-auto space-y-8">
      <header className="space-y-2">
        <h2 className="text-3xl font-semibold text-slate-900 dark:text-slate-50">Roadmap</h2>
        <p className="text-slate-700 dark:text-slate-300 text-sm md:text-base max-w-3xl">
          Les jalons présentés ici illustrent la trajectoire MixMind : rendre visibles les briques déjà disponibles,
          clarifier la direction Academy / Play / Assist, et rassurer écoles et familles sur la vision long terme.
        </p>
      </header>

      <section className="grid gap-4 md:grid-cols-2">
        {STEPS.map((step) => (
          <div key={step.title} className="mm-surface p-5 space-y-2 text-slate-900 dark:text-slate-100">
            <div className="flex justify-between items-start gap-3">
              <div>
                <h3 className="text-xl font-bold text-slate-900 dark:text-slate-50">{step.title}</h3>
                <p className="text-sm text-slate-600 dark:text-slate-200">{step.subtitle}</p>
              </div>
              <RoadmapBadge status={step.status} />
            </div>
            <ul className="list-disc list-inside text-sm text-slate-700 dark:text-slate-200 space-y-1.5">
              {step.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </section>

      <section className="mm-surface p-5 text-sm text-slate-700 dark:text-slate-300 leading-relaxed">
        <p>
          Cette roadmap est volontairement flexible : chaque étape est pensée pour apporter une valeur concrète aux
          élèves, enseignants et familles, tout en gardant MixMind à taille humaine. Les jalons pourront évoluer
          naturellement avec les retours des utilisateurs. Le but : rendre lisible ce qui est déjà disponible, montrer la
          direction Academy / Play / Assist, et rassurer les écoles et familles sur la vision long terme.
        </p>
      </section>
    </div>
  );
}
